import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=76c57f28&scoped=true&"
import script from "./ClientDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c57f28",
  null
  
)

/* custom blocks */
import block0 from "./ClientDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports